import dayjs from 'dayjs'
import Form from '../../types/api/form'
import FormSet from '../../types/api/form-set'
import {
    PrintedFormSetSnapshot,
    PrintedFormSnapshot,
} from '../../types/api/components/shipment/printed-form-set-snapshot'

const toPrintedFormSnapshot = (form: Form): PrintedFormSnapshot | null => {
    if (!form.documentId) return null

    return {
        id: form.id,
        documentId: form.documentId,
        num: form.num,
        oldNum: form.oldNum,
        color: form.color,
        colorName: form.colorName,
        inStock: form.inStock,
        dateOfFailure: form.dateOfFailure,
    }
}

export const buildPrintedFormSetSnapshot = (
    formSet: FormSet,
    capturedAt: string = dayjs().toISOString()
): PrintedFormSetSnapshot => {
    const forms = (formSet.forms ?? [])
        .map(toPrintedFormSnapshot)
        .filter((form): form is PrintedFormSnapshot => form !== null)

    return {
        capturedAt,
        formSetId: formSet.id,
        formSetDocumentId: formSet.documentId,
        forms,
    }
}
